import React from 'react';
import { Routes, Route, Navigate  } from 'react-router-dom';
import EmployeeDashboard from '../pages/EmployeeDashboard';
import Profile from '../components/employee/Profile';
import AssignedCandidatesList from '../components/employee/AssignedCandidatesList';
import CandidateDetails from '../components/employee/CandidateDetails';
import QuickBGV from '../components/employee/QuickBGV';
import QuickBGVDash from '../components/employee/QuickBGVDash';
import AIModules from '../components/employee/AIModules';

import ResumeParser from "../components/employee/resumeParserAI/AIResumeParser";

import PayslipBankUpload from '../components/employee/PayslipAndBankStatementCheck/PayslipBankUpload';
import UtilityBillUpload from '../components/employee/UtilityBillCheck/UtilityBillUpload';

import DocumentUpload from "../components/employee/documentForgeryAI/DocumentUpload";
import FaceMatchForm from "../components/employee/faceMatchingAI/FaceMatchForm"; 
import AadhaarCheck from '../components/employee/AadhaarCheck';
import QuickUANCheck from '../components/employee/QuickUANCheck';
import QuickCriminalCheck from '../components/employee/QuickCriminalCheck';
import QuickBgvFinalReport from '../components/employee/QuickBgvFinalReport';


const EmployeeRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" />} />
      <Route path="dashboard" element={<EmployeeDashboard />} />
      <Route path="profile" element={<Profile />} />
      <Route path="assignedCandidates" element={<AssignedCandidatesList />} />
      <Route path="assignedCandidates/:status" element={<AssignedCandidatesList />} />
      <Route path="candidateDetails/:id/*" element={<CandidateDetails />} />
      
      <Route path="quickbgv" element={<QuickBGV />} />
      <Route path="quickbgv-dashboard/:id/*" element={<QuickBGVDash />} />
      <Route path='aadhaarcheck' element={<AadhaarCheck/>}/>
      <Route path='quickuancheck' element={<QuickUANCheck/>}/>
      <Route path='quickcriminalcheck' element={<QuickCriminalCheck/>}/>
      <Route path="/quickbgv-report/:candidateId" element={<QuickBgvFinalReport />} />


      <Route path="aiModules" element={<AIModules />} />
      <Route path="aiModules/bank-statement" element={<PayslipBankUpload />} />
      <Route path="aiModules/utility-bill" element={<UtilityBillUpload />} />
      <Route path="aiModules/resume-parser" element={<ResumeParser />} />
      <Route path="aiModules/document-forgery" element={<DocumentUpload />} />
      <Route path="aiModules/face-matching" element={<FaceMatchForm />} /> 

       <Route path="quickbgv" element={<QuickBGV />} />
      <Route path="quickbgv-dashboard/:id/*" element={<QuickBGVDash />} />
      <Route path='aadhaarcheck/:id' element={<AadhaarCheck/>}/>
      <Route path='quickuancheck/:id' element={<QuickUANCheck/>}/>
      <Route path='quickcriminalcheck/:id' element={<QuickCriminalCheck/>}/>

      <Route path="/quickbgv-report/:candidateId" element={<QuickBgvFinalReport />} />
      
    </Routes>
  );
};

export default EmployeeRoutes;